<template>
    <TaxSituationFormFields></TaxSituationFormFields>
    <div class="border-t border-gray-300">
        <TaxResidencyFormFields></TaxResidencyFormFields>
    </div>
</template>

<script setup lang="ts">
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import TaxSituationFormFields from './fields/TaxSituationFormFields.vue'
import { getTinValidationRules } from '../../../../validation'
import TaxResidencyFormFields from './fields/TaxResidencyFormFields.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'

initializeNaturalWidgetForm(
    { ...getNaturalWidgetFormValidationRules('tax_situation'), tin: getTinValidationRules() },
    {
        ...usePersonalAccountDataState().naturalProfile.compliance_profiles.esac,
        tin: usePersonalAccountDataState().naturalProfile.tax_residencies,
    }
)
</script>
